import { render, staticRenderFns } from "./SendMessageTargetOtherUserModal.vue?vue&type=template&id=68b84904&lang=pug"
import script from "./SendMessageTargetOtherUserModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetOtherUserModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTargetOtherUserModal.vue?vue&type=style&index=0&id=68b84904&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports